import { render, staticRenderFns } from "./IconMoreSettings.vue?vue&type=template&id=a1682a8a&scoped=true&"
import script from "./IconMoreSettings.vue?vue&type=script&lang=js&"
export * from "./IconMoreSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1682a8a",
  null
  
)

export default component.exports